"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    throttle: ()=>throttle,
    transformSOPQName: ()=>transformSOPQName
});
function throttle(func, delay) {
    let isThrottling = false;
    return function(...args) {
        if (!isThrottling) {
            func.apply(this, args);
            isThrottling = true;
            setTimeout(()=>{
                isThrottling = false;
            }, delay);
        }
    };
}
const pclnPropertyTypeGroupingConfig = {
    1001: 'Apartment',
    1002: 'Hostel',
    1003: 'Hotel',
    1004: 'Motel',
    1005: 'Resort',
    1006: 'Residence',
    1007: 'Farm stay',
    1008: 'Holiday park',
    1009: 'Bungalow',
    1010: 'Villa',
    1011: 'Campsite',
    1012: 'Boat/cruise',
    1013: 'Inn',
    1014: 'Aparthotel',
    1015: 'Holiday home',
    1016: 'Lodge',
    1017: 'Homestay',
    1018: 'Tent',
    1019: 'Capsule hotel',
    1020: 'Love hotel',
    1021: 'Traditional stay',
    1022: 'Guesthouse',
    1023: 'Student accommodation'
};
const transformSOPQName = ({ starRating, location, pclnPropertyTypeId })=>`A ${starRating}-star ${pclnPropertyTypeGroupingConfig[pclnPropertyTypeId]} in the ${location?.zoneName} `;
exports.throttle = __webpack_exports__.throttle;
exports.transformSOPQName = __webpack_exports__.transformSOPQName;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "throttle",
    "transformSOPQName"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
